import type {ReactElement} from 'react';
import React from 'react';
import type {NewFeatureBadgeProps} from './new-feature-badge.types';
import {NewFeatureBadgeColorType} from './new-feature-badge.types';
import styles from './new-feature-badge.module.scss';
import {Text} from '@Components/text';

export function NewFeatureBadge({colorType, className = ''}: NewFeatureBadgeProps): ReactElement {
  const getBackgroundColorClass = (): string => {
    switch (colorType) {
      case NewFeatureBadgeColorType.PREMIUM:
        return 'bg-premium-150';
      case NewFeatureBadgeColorType.SECONDARY:
        return 'bg-secondary-150';
      default:
        return 'bg-secondary-150';
    }
  };

  const getPillShadowBackgroundColorClass = (): string => {
    switch (colorType) {
      case NewFeatureBadgeColorType.PREMIUM:
        return 'bg-neutral-0';
      case NewFeatureBadgeColorType.SECONDARY:
        return 'bg-neutral-80';
      default:
        return 'bg-neutral-80';
    }
  }

  return (
    <div className="flex-v-row flex-center">
      <div className={`${styles.newFeatureBadge} ${getBackgroundColorClass()} flex-center ${className}`}>
        <Text val={window.i18next.t('pmwjs_new')} className={`content-body-white ${styles.text}`} />
      </div>
      <div className={`${styles.pillShadow} ${getPillShadowBackgroundColorClass()}`} />
    </div>
  );
}
